try {
    require('./init');
    var Form = require('./form');
    var View = require('./view');
    var ExtensionService = require('live/services/extension');

    const samter = {
        name: 'SAMTER',
        type: 'liverig-samter',
        origin: 'Plugin Petrobras',
        icon: '/content/plugin-petrobras/samter.png',
        ui: {
            form: Form,
            view: View
        }
    };

    ExtensionService.register(samter);
}
catch (e) {
    console.error(e)
}
